/** @format */

import {
  KPI_WIDTH,
  MIN_PLAN_LETTERS,
  MIN_TITLE_LETTERS,
  PLAN_LETTER_WIDTH,
  TITLE_LETTER_WIDTH,
} from '../constants';

const calcKpiColumnSize = (titleLength: number, planLength: number): number => {
  let size = KPI_WIDTH;
  let planWidth = 0;
  let titleWidth = 0;

  if (planLength > MIN_PLAN_LETTERS) {
    planWidth = (planLength - MIN_PLAN_LETTERS) * PLAN_LETTER_WIDTH;
  }
  if (titleLength > MIN_TITLE_LETTERS) {
    titleWidth = (titleLength - MIN_TITLE_LETTERS) * TITLE_LETTER_WIDTH;
  }

  size += Math.max(planWidth, titleWidth);

  return size;
};

export {calcKpiColumnSize};
